import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { title } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useOrdersList() {
  // Use toast
  const toast = useToast();

  const refOrderListTable = ref(null);

  //fileter
  const supplierFilter = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "order_date", label: "日期", sortable: true },
    { key: "po_number", label: "入貨單號", sortable: true },
    {
      key: "supplier.name",
      stickyColumn: true,
      label: "供應商",
    },
    { key: "remark", label: "備註" },
    { key: "order_products", label: "產品" },
    { key: "actions", label: "操作" },
  ];

  const perPage = ref(50);
  const totalOrders = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("order_date");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refOrderListTable.value
      ? refOrderListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalOrders.value,
    };
  });

  const refetchData = () => {
    refOrderListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, supplierFilter], () => {
    refetchData();
  });

  const fetchOrders = (ctx, callback) => {
    store
      .dispatch("app-order/fetchOrders", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        supplier_id: supplierFilter.value,
      })
      .then((response) => {
        const { purchase_orders, total } = response.data;
        callback(purchase_orders);
        totalOrders.value = total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching orders list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const supplierOptions = ref([]);

  onMounted(() => {
    store
      .dispatch("app/fetchOptionList", {
        supplier: true,
      })
      .then((response) => {
        supplierOptions.value = response.data.suppliers;
      })
      .catch((error) => {
        console.log(error);
      });
  });

  return {
    fetchOrders,
    tableColumns,
    perPage,
    currentPage,
    totalOrders,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refOrderListTable,
    ability,
    refetchData,
    supplierFilter,
    supplierOptions,
    // Extra Filters
  };
}
